import { render } from "./TagConsentDetailsView.vue?vue&type=template&id=50e90525"
import script from "./TagConsentDetailsView.vue?vue&type=script&lang=js"
export * from "./TagConsentDetailsView.vue?vue&type=script&lang=js"

import "./TagConsentDetailsView.vue?vue&type=style&index=0&id=50e90525&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__